/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Close_LabelInputs */



/**
* | output |
* | --- |
* | "Close Media Import" |
*
* @param {Media_Import_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_close_label = /** @type {((inputs?: Media_Import_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer l'importation des medias")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienimport schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi importazione media")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть импорт медиафайлов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar importación de medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭媒体导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアのインポートを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया आयात बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar Importação de Mídia")
	return /** @type {LocalizedString} */ ("Close Media Import")
});